import React from 'react';
import { ToolTip } from 'clm-components';
import {
  includes, replace, first, last, split,
} from 'lodash';
import { ItemListConfig, FooterListConfig, SubDrawerItem } from '../../types/Drawer';
import { doesHavePermission } from '../Permission/utils';

const tooltipBgColor = '#444444';

const getTooltipForDisabled = (component: React.ReactElement, isDisabled: boolean) => {
  if (isDisabled) {
    return (
      <ToolTip
        title={
          (
            <span>coming real soon!</span>
          )
        }
        styles={{
          tooltip: {
            fontSize: '12px',
            padding: '2px 4px',
            bottom: '10px',
            backgroundColor: tooltipBgColor,
            color: 'white',
            borderColor: tooltipBgColor,
          },
          arrow: {
            color: tooltipBgColor,
            borderColor: tooltipBgColor,
          },
        }}
        placement="bottom"
      >
        {React.cloneElement(component)}
      </ToolTip>
    );
  }
  return (React.cloneElement(component));
};

export const isItemDisabled = (
  item: ItemListConfig | FooterListConfig | SubDrawerItem,
  disabledKeys: string[],
) => disabledKeys.includes(item.key) || item.disabled;

export const isItemHidden = (
  item: ItemListConfig | FooterListConfig | SubDrawerItem,
  hiddenKeys: string[],
) => hiddenKeys.includes(item.key) || item.hidden;

export const disabledFunction = () => {
  console.log('disabled');
};

const auditPagePath = '/applications';
const reviewPagePath = '/review';

export const getDrawerApplicationPagePath = (
  allowedPermissions: string[],
  disallowedPermissions: string[],
  path: string,
) => {
  const canViewAuditPage = doesHavePermission(['auditPage.view'], allowedPermissions, disallowedPermissions);
  const canViewReviewPage = doesHavePermission(['reviewPage.view'], allowedPermissions, disallowedPermissions);

  if (canViewAuditPage && canViewReviewPage) {
    return path === reviewPagePath ? reviewPagePath : auditPagePath;
  }
  if (canViewAuditPage) {
    return auditPagePath;
  }
  if (canViewReviewPage) {
    return reviewPagePath;
  }
  return auditPagePath;
};

export const getHiddenAndDisabledDrawerKeysFromPermissions = (
  disallowedPermissions: string[] = [],
) => {
  const hiddenNavKeys: string[] = [];
  const disabledNavKeys: string[] = [];
  const navbarDisallowedPermissions = disallowedPermissions.filter(
    (permission) => includes(permission, 'navbar.'),
  );
  navbarDisallowedPermissions.forEach((disallowedPermission) => {
    const navItem = replace(disallowedPermission, 'navbar.', '');
    const navKey = first(split(navItem, '.')) || '';
    const permission = last(split(navItem, '.')) || '';
    if (permission === '*' || permission === 'view') {
      hiddenNavKeys.push(navKey);
      disabledNavKeys.push(navKey);
    } else if (permission === 'interact') {
      disabledNavKeys.push(navKey);
    }
  });
  return { hiddenNavKeys, disabledNavKeys };
};

export default getTooltipForDisabled;
